import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import {
  DetailsList,
  Selection,
  DetailsListLayoutMode,
  SelectionMode,
} from 'office-ui-fabric-react/lib/DetailsList';

import { localizable } from 'components/Localization';
import Money from 'components/Money';
import BaseStep from '../components/BaseStep';

const columns = (t) => [
  {
    key: 'name',
    name: t('Name'),
    fieldName: 'name',
    minWidth: 150,
    maxWidth: 400,
    isSorted: true,
    isSortedDescending: false,
  },
  {
    key: 'submittedValue',
    name: t('Submitted value'),
    fieldName: 'submittedValue',
    minWidth: 100,
    maxWidth: 150,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'validity',
    name: t('Expiration date'),
    fieldName: 'validity',
    minWidth: 100,
    maxWidth: 150,
    isSorted: false,
    isSortedDescending: false,
  },
];

@inject('app')
@localizable
@observer
class IncreaseStep1 extends BaseStep {
  constructor(props) {
    super(props);

    this.selection = new Selection({
      onSelectionChanged: this.handleSelectionChanged,
    });
    this.selection.setModal(true);
  }

  handleRenderItemColumn = (item, _, column) => {
    const { t } = this.props;
    const content = item[column.fieldName];

    switch (column.key) {
      case 'name':
        return <span>{this.renderBuyerName(item.item)}</span>;
      case 'validity':
        return (
          <Fragment>{content ? content.toFormatedDateString() : ''}</Fragment>
        );
      case 'submittedValue':
        return (
          <Money
            value={content}
            defaultValue={content === 'hidden' ? t(content) : content}
            currency={this.props.app.currency.code}
            locale={this.props.intl.locale}
          />
        );
      default:
        return <span>{content}</span>;
    }
  };

  handleSelectionChanged = () => {
    var { store } = this.props;
    store.acceptedOffers = _.flatten(this.selection.getSelection()).map(
      (i) => i.buyerId
    );
  };

  render() {
    var { store, t } = this.props;
    var { eligibleOffers } = store;

    return (
      <Fragment>
        <ul className="hint">
          <li>{t('Select customers')}</li>
          <li>{t('All other offers will be rejected')}</li>
          <li>{t('Invite more customers after start of next round')}</li>
        </ul>

        <div className="control">
          <DetailsList
            columns={columns(t)}
            items={eligibleOffers || []}
            selection={this.selection}
            onRenderItemColumn={this.handleRenderItemColumn}
            enterModalSelectionOnTouch={true}
            selectionPreservedOnEmptyClick={true}
            compact={true}
            layoutMode={DetailsListLayoutMode.justified}
            selectionMode={SelectionMode.multiple}
          />
        </div>
      </Fragment>
    );
  }
}

export default IncreaseStep1;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Increase/Step1.jsx